import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import LigneImpotDetaille from "./LigneImpot";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import "./ContexteFiscal.css";

function RenteViagere(props) {
  const { Outil } = props;
  const context = useContext(AppContext);

  return (
    <div className="revenuspro-container">
      {/* Header séparé */}
      <div className="header-card">
        <div className="category-column">
          <span className="header-icon">💰</span>
          Paramètres des rentes viagères à titre onéreux
        </div>
        <div className="value-column">
          <span className="header-icon">💰</span>
          Montant
        </div>
      </div>

      {/* Conteneur des cartes de contenu */}
      <div className="card-list-container">
        {/* Moins de 50 ans */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📅</div>
            Moins de 50 ans
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantRenteMoins50"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantRenteMoins50")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* De 50 à 59 ans */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📅</div>
            De 50 à 59 ans
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantRente5059"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantRente5059")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* De 60 à 69 ans */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📅</div>
            De 60 à 69 ans
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantRente6069"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantRente6069")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* A partir de 70 ans */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📅</div>
            A partir de 70 ans
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantRente70"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantRente70")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RenteViagere;
